export default __webpack_public_path__ + "static/media/advcoruja.ede5ee09.png";